module.exports = __webpack_public_path__ + "static/img/0762.60ec6a2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/0762.jpg
// module id = 101
// module chunks = 0